export class ContentModal {
    private backdrop: HTMLDivElement;
    private card: HTMLDivElement;

    constructor(
        private options: {
            title: string;
            content: string;
            isHtml?: boolean;
            direction?: 'ltr' | 'rtl';
            onClose: () => void;
        }
    ) {
        this.backdrop = document.createElement('div');
        this.backdrop.className = 'modal-backdrop';
        this.backdrop.onclick = this.options.onClose;

        this.card = document.createElement('div');
        this.card.className = 'modal-card modal-card-content';
        if (this.options.direction) {
            this.card.dir = this.options.direction;
        }
        this.card.onclick = (e) => e.stopPropagation();

        const closeBtn = document.createElement('button');
        closeBtn.className = 'modal-close-x';
        closeBtn.onclick = this.options.onClose;
        closeBtn.innerHTML = `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        `;
        this.card.appendChild(closeBtn);

        const header = document.createElement('h2');
        header.className = 'modal-header';
        header.textContent = this.options.title;
        this.card.appendChild(header);

        const contentBox = document.createElement('div');
        contentBox.className = 'content-box';
        if (this.options.isHtml) {
            contentBox.innerHTML = this.options.content;
        } else {
            contentBox.textContent = this.options.content;
        }
        this.card.appendChild(contentBox);

        this.backdrop.appendChild(this.card);

        this.handleEsc = this.handleEsc.bind(this);
        document.addEventListener('keydown', this.handleEsc);
    }

    private handleEsc(e: KeyboardEvent) {
        if (e.key === 'Escape') this.options.onClose();
    }

    public getElement() {
        return this.backdrop;
    }

    public destroy() {
        document.removeEventListener('keydown', this.handleEsc);
        this.backdrop.remove();
    }
}
